module.exports = __webpack_public_path__ + "static/media/btn_android_deu.e115fc50.png";